import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { operationHelpers } from "../../../../operations"
import { SaleForm } from "./saleForm"
import { Budget, Customer, SaleOrder } from "../../../state/types"
import { useCustomerLoaders } from "../../../loaders/customerLoaders"
import { TableName } from "../../../../../tables"
import { useLocation, useNavigate } from "react-router-dom"
import { useSaleOperationHooks } from "../../../hooks/saleOperationHooks"

export const SaleFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const isSale = tableName === TableName.SALE_ORDERS
    const sale = isSale ? dataType as O<SaleOrder> : undefined
    const budget = !isSale ? dataType as O<Budget> : undefined
    const saleOrBudget = sale || budget

    const [ready, setReady] = useState(false)
    const [customer, setCustomer] = useState<O<Customer>>()

    const { describeCode } = operationHelpers
    const { isEditable } = useSaleOperationHooks()
    const { getRoutePath } = useRoutesHooks()
    const { state } = useLocation()
    const navigate = useNavigate()

    const keepPrices = state?.keepPrices ?? false

    const customerLoaders = useCustomerLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        if (sale && !(await isEditable(sale))) {
            navigate(getRoutePath(RoutePath.SALES, sale.id))
        } else if (state?.customerId || saleOrBudget) {
            const { loadCustomer } = customerLoaders()
            const loadedCustomer = await loadCustomer(state?.customerId || saleOrBudget!.customerId)
            setCustomer(loadedCustomer)
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => `${sale ? 'Editar' : 'Crear'} Venta${sale ? ' ' + describeCode(sale) : ''}`, [sale])
    const crumbs = useGetCrumbs(
        isSale ? 'Ventas': 'Presupuestos',
        isSale ? RoutePath.SALES : RoutePath.BUDGETS,
        saleOrBudget && describeCode(saleOrBudget),
        saleOrBudget?.id,
        sale ? 'Editar' : 'Crear' + (budget ? ' Venta' : '')
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <SaleForm
                sale={sale}
                budget={budget}
                customer={customer}
                keepPrices={keepPrices}
            />
        </PanelLoader>
    )
}
